import {Component, Input, OnInit} from '@angular/core';
import {StudentModel} from '../../../models/authentication/student.model';

@Component({
  selector: 'app-evo-student-profile-image',
  templateUrl: './evo-student-profile-image.component.html',
  styleUrls: ['./evo-student-profile-image.component.css']
})
export class EvoStudentProfileImageComponent implements OnInit {


  _type = 'small';

  _student: StudentModel;

  /**
   * can be of type small, medium, large or fill.
   * Where small = 36px
   * medium = 44px
   * large = 50px
   * fill = 100%.
   * If an unknown value is passed it will default to small.
   */
  @Input('type')
  get type(): string {
    return this._type;
  }

  set type(value: string) {
    this._type = value;
  }

  @Input('student')
  get student(): StudentModel {
    return this._student;
  }

  set student(value: StudentModel) {
    this._student = value;
  }

  constructor() { }

  ngOnInit() {
  }


  getContentSize(): string {

    if (this.type === 'medium') {

      return '36px';

    } else if (this.type === 'large') {

      return '40px';

    } else if (this.type === 'fill') {

      return 'calc(100% - 4px)';

    }

    // The default size of the profile
    return '32px';

  }

  getTotalSize(): string {

    if (this.type === 'medium') {

      return '40px';

    } else if (this.type === 'large') {

      return '44px';

    } else if (this.type === 'fill') {

      return '100%';

    }

    return '36px';
  }

  getBorderRadius() {

    if (this.type === 'medium') {
      return '20px';
    } else if (this.type === 'large') {
      return '22px';
    } else if (this.type === 'fill') {
      return 'calc(50% + 4px)';
    }

    return '18px';
  }

  /*
  Currently not used as all of the profile images have 2 px border width
  borderWidth(): string {

    if (this.type === 'medium') {

    } else if (this.type === 'large') {

    } else if (this.type === 'fill') {
      return '4%';
    }

    return '2px';

  }
   */


}
